import * as React from 'react';
import './ContentViewer.scss';
import { EditModeWrapper } from './EditModeWrapper';
import { ContentLoader } from './ContentLoader';
import { useState } from 'react';
import { getValidColor, resolveStyleVariables } from '../../utils/themeUtil';

const isNull = (x) => x === null || x === undefined;

const ifNull = (x, fallback) => isNull(x) ? fallback : x;

export const SectionElement = (props) => {

    const item = props.item;
    const [layoutsReady, setLayoutsReady] = useState({});
    const allLayoutsReady = () => !item.contents || item.contents.filter(c => layoutsReady[c.id]).length == item.contents.length;

    const setChildLayoutReady = (id, val) => {
        //console.log(`section ${item?.id} setChildLayoutReady ${id}:${val}`);
        setLayoutsReady({
            ...layoutsReady,
            [id]: val
        })
    }

    React.useEffect(() => {
        if (item) {
            //console.log(`section ${item.id} layoutsReady`, layoutsReady, item.contents, allLayoutsReady());
            props.setLayoutReady?.(allLayoutsReady())
        }
    }, [item, layoutsReady])

    if (!item) return null;

    
    const style = {
        border: getValidColor(item.data?.border || '--border-color'),
        margin: item.data?.margin || '0',
        backgroundColor: getValidColor(item.data?.backgroundColor || '--background-color'),
        padding: item.data?.padding || '10px'
    }


    if (!isNull(item.data?.borderBottom)) {
        style.borderBottom = item.data?.borderBottom;
    }

    if (item.data?.sticky) {
        style.position = "sticky";
        style.top = Number(item.data?.stickyFromTop) || 0;
        style.zIndex = 100;
    }

    const allowHeading = !props.asTab;
    const showHeading = allowHeading && (item.title || item.data?.subTitle);
    const titleStyles = item.data?.titleStyle && resolveStyleVariables(item.data?.titleStyle) || {}
    const subTitleStyles = item.data?.subTitleStyle && resolveStyleVariables(item.data?.subTitleStyle) || {}


    return <EditModeWrapper className='has-children'
        item={item} edit={props.edit} restoredItem={props?.restoredItem} reloadItem={props.reloadItem} reloadParent={props.reloadParentItem}
        pageLevel={props.pageLevel}
    >
        <div id={item.id} className='section-element ' style={style}>
            {showHeading ? <div className='section-element-heading page-width'>
                {item.title ?
                    <div className='title' style={{ ...titleStyles}}>
                        {item.title}
                    </div>
                    : null
                }
                {item.data?.subTitle ?
                <div className='subtitle' style={{ ...subTitleStyles }}>
                        {item.data?.subTitle}
                    </div>
                    : null
                }
                </div>
            : null}
            <div className='section-element-content'>
                {item.contents?.map(child => <ContentLoader
                    key={child.id}
                    id={child.id}
                    reloadParentItem={props.reloadItem}
                    edit={props.edit}
                    restore={props.restore}
                    restoredItem={child?.deleted}
                    pageLevel={props.pageLevel}
                    setLayoutReady={(val) => setChildLayoutReady(child.id, val)} />)}
                {(item.contents?.length > 0 || showHeading) ? null : (props.edit?.editMode ? `empty` : null)}
            </div>
        </div>
    </EditModeWrapper>;
}
